var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"item.calories",fn:function({ item }){return [_c('v-chip',{attrs:{"color":_vm.getColor(item.calories),"dark":""}},[_vm._v(_vm._s(item.calories))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }